import { createId } from "@paralleldrive/cuid2";
import FileHandler from "@tiptap-pro/extension-file-handler";
import { uploadFile } from "@/hooks/useFileUpload";
import type { SessionData } from "@/utils/getSession";

export const FileExtension = ({
	// mimeTypes,
	club,
	session,
	onAttachmentUpload,
	onUploadProgress,
}: {
	mimeTypes?: string[];
	club: string;
	session?: Partial<SessionData>;
	onAttachmentUpload?: (file: {
		id: string;
		rawID: string;
		name: string;
		signedUrl: string;
		size?: string;
	}) => void;
	onUploadProgress?: ({
		uploadId,
		progress,
	}: {
		uploadId: string;
		progress: number;
	}) => void;
}) =>
	FileHandler.configure({
		onDrop: (editor, files) => {
			if (!files.length) {
				return;
			}

			files.forEach(async (file) => {
				const uploadId = createId();

				const result = await uploadFile({
					file,
					session,
					club,
					uploadId,
					onUploadProgress,
				});

				if (file.type.startsWith("image/")) {
					editor.commands.setMedia({
						fileId: result.id,
						title: result.name,
						width: "600",
						height: "600",
						dataAlign: "center",
					});
				} else if (file.type.startsWith("video/")) {
					editor.commands.setMuxVideo({
						fileId: result.id,
						assetId: result.muxId!,
					});
				} else {
					onAttachmentUpload?.({
						id: result.globalId,
						rawID: result.id,
						name: result.name,
						signedUrl: result.url,
						size: result.size,
					});
				}
			});
		},
		onPaste: (editor, files) => {
			if (!files.length) {
				return;
			}

			files.forEach(async (file) => {
				const uploadId = createId();

				const result = await uploadFile({
					file,
					session,
					club,
					uploadId,
					onUploadProgress,
				});

				if (file.type.startsWith("image/")) {
					editor.commands.setMedia({
						fileId: result.id,
						title: result.name,
						width: "600",
						height: "600",
						dataAlign: "center",
					});
				} else {
					onAttachmentUpload?.({
						id: result.globalId,
						rawID: result.id,
						name: result.name,
						signedUrl: result.url,
						size: result.size,
					});
				}
			});
		},
		// allowedMimeTypes: mimeTypes,
	});
